module.exports = __webpack_public_path__ + "img/faq-mb.b1e5bb9b.png";